/* Current Nostalgia - homepage category collages (v66; even sizing and spacing v67).

   1. Same size. Product photos come with very different amounts of empty space around the
      item (a sock photographed tight, a sneaker with a wide margin), so at the same cell size
      some pieces looked tiny and others huge. Each photo is read once, the item's actual outline
      is found (ignoring transparent or white background), and the photo is scaled and centred so
      every item covers the same area of its cell (never spilling past it). Photos that can't be read are left as they are.

   2. Styles. The tile's look is set in the theme editor (Categories section > Collage style).
      For previewing, ?collage=grid|mosaic|flatlay|marquee|spotlight in the page URL overrides it.
        grid       even grid of pieces
        mosaic     one large piece with smaller ones around it
        flatlay    pieces laid out loosely at slight angles, overlapping, like a flat-lay photo
        marquee    two rows drifting in opposite directions
        spotlight  one large piece at a time, fading through the collection */
(function () {
  if (window.__cnCollage) return;
  window.__cnCollage = true;

  var STYLES = ['grid', 'mosaic', 'flatlay', 'marquee', 'spotlight'];
  /* Share of the cell each item's outline should cover. Matching area rather than width or
     height is what makes a wide sneaker, a tall tee and a slim sock read as the same size. */
  var AREA = { grid: 0.58, mosaic: 0.58, flatlay: 0.78, marquee: 0.58, spotlight: 0.46 };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function outline(img) {
    if (img.__cnBox !== undefined) return img.__cnBox;
    var w = img.naturalWidth, h = img.naturalHeight, box = null;
    if (w && h) {
      var S = 96, sc = S / Math.max(w, h);
      var cw = Math.max(1, Math.round(w * sc)), ch = Math.max(1, Math.round(h * sc));
      try {
        var c = document.createElement('canvas');
        c.width = cw; c.height = ch;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(img, 0, 0, cw, ch);
        var d = x.getImageData(0, 0, cw, ch).data;
        var x0 = cw, y0 = ch, x1 = -1, y1 = -1;
        for (var j = 0; j < ch; j++) {
          for (var i = 0; i < cw; i++) {
            var k = (j * cw + i) * 4;
            if (d[k + 3] < 24) continue;
            if (d[k] > 236 && d[k + 1] > 236 && d[k + 2] > 236) continue;
            if (i < x0) x0 = i; if (i > x1) x1 = i;
            if (j < y0) y0 = j; if (j > y1) y1 = j;
          }
        }
        if (x1 >= 0) box = { x: x0 / cw, y: y0 / ch, w: (x1 - x0 + 1) / cw, h: (y1 - y0 + 1) / ch };
      } catch (e) { box = null; }
    }
    img.__cnBox = box;
    return box;
  }

  function fit(img, fill, cap) {
    cap = cap || 0.95;
    var cell = img.parentNode;
    var W = cell.clientWidth, H = cell.clientHeight;
    if (!W) return;
    /* ask for a photo sized to the cell (the large mosaic / spotlight pieces need a bigger one) */
    var want = Math.round(Math.max(W, H)) + 'px';
    if (img.getAttribute('sizes') !== want) img.setAttribute('sizes', want);
    if (!H || !img.complete || !img.naturalWidth) return;
    var b = outline(img);
    if (!b) return;
    var nw = img.naturalWidth, nh = img.naturalHeight;
    var k = Math.min(W / nw, H / nh), dw = nw * k, dh = nh * k;
    var ox = (W - dw) / 2, oy = (H - dh) / 2;
    var bw = b.w * dw, bh = b.h * dh;
    var cx = ox + (b.x + b.w / 2) * dw, cy = oy + (b.y + b.h / 2) * dh;
    /* v67: size against a square the width of the cell's shorter side, so a short, wide cell
       (a wide tile, or a phone) doesn't let wide items balloon while tall ones stay small */
    var Q = Math.min(W, H);
    var s = Math.sqrt(fill * Q * Q / (bw * bh));
    s = Math.min(s, cap * Q / bw, cap * Q / bh);
    s = Math.max(0.5, Math.min(s, 4));
    img.style.setProperty('--hx', (W / 2) + 'px');
    img.style.setProperty('--hy', (H / 2) + 'px');
    img.style.setProperty('--mx', (-cx) + 'px');
    img.style.setProperty('--my', (-cy) + 'px');
    img.style.setProperty('--s', s.toFixed(4));
    img.classList.add('is-fit');
  }

  /* v67: pick the column count that keeps cells closest to square for this tile's shape -
     a wide tile gets 6 across in 2 rows rather than 4 stretched columns, a tall one 3 across.
     Only for the even layouts (grid, flat-lay); the others have their own arrangement. */
  /* v68: the grid is always completely full. Every columns x rows combination that the tile's
     pieces can fill exactly is tried; the one whose cells are closest to square wins, with a
     small nudge towards showing more pieces and a floor on how small a cell may get (so a
     phone gets 3 x 3 or 4 x 3, never a cramped 6 x 2). Pieces past the chosen count are hidden,
     so no row ends in a gap and nothing is cut off. */
  var MIN_CELL = 64;
  function layout(col) {
    var cells = Array.prototype.filter.call(col.children, function (c) {
      return c.classList.contains('cnh-collage__cell');
    });
    var N = cells.length;
    var W = col.clientWidth, H = col.clientHeight;
    if (!N || !W || !H) return;
    var best = null, bestScore = Infinity;
    for (var c = 2; c <= 6; c++) {
      for (var r = 1; r <= 4; r++) {
        var k = c * r;
        if (k > N || k < Math.min(4, N)) continue;
        var cw = W / c, ch = H / r;
        if (Math.min(cw, ch) < MIN_CELL && k > 4) continue;
        var score = Math.abs(Math.log(cw / ch)) + (N - k) * 0.06;
        if (score < bestScore) { bestScore = score; best = { c: c, r: r, k: k }; }
      }
    }
    if (!best) best = { c: Math.min(N, 3), r: Math.ceil(Math.min(N, 9) / Math.min(N, 3)), k: Math.min(N, 9) };
    cells.forEach(function (cell, i) { cell.style.display = i < best.k ? 'flex' : 'none'; });
    col.style.gridTemplateColumns = 'repeat(' + best.c + ', minmax(0, 1fr))';
    col.style.gridTemplateRows = 'repeat(' + best.r + ', minmax(0, 1fr))';
  }

  function styleFor(section) {
    var q = null;
    try { q = new URL(location.href).searchParams.get('collage'); } catch (e) {}
    if (q && STYLES.indexOf(q) > -1) return q;
    var s = section.getAttribute('data-cn-collage-style');
    return STYLES.indexOf(s) > -1 ? s : 'grid';
  }

  function buildMarquee(col) {
    if (col.getAttribute('data-cn-mq')) return;
    col.setAttribute('data-cn-mq', '1');
    var cells = Array.prototype.slice.call(col.querySelectorAll(':scope > .cnh-collage__cell'));
    var rows = [[], []];
    cells.forEach(function (c, i) { rows[i % 2].push(c); });
    col.innerHTML = '';
    rows.forEach(function (list, r) {
      var row = document.createElement('span');
      row.className = 'cnh-mq__row' + (r ? ' cnh-mq__row--rev' : '');
      var track = document.createElement('span');
      track.className = 'cnh-mq__track';
      list.forEach(function (c) { track.appendChild(c); });
      list.forEach(function (c) { track.appendChild(c.cloneNode(true)); });
      row.appendChild(track);
      col.appendChild(row);
    });
  }

  function startSpotlight(col, delay) {
    if (col.getAttribute('data-cn-spot')) return;
    col.setAttribute('data-cn-spot', '1');
    var cells = col.querySelectorAll('.cnh-collage__cell');
    if (!cells.length) return;
    var i = 0;
    /* every piece takes a turn in view, so load them all up front rather than lazily */
    Array.prototype.forEach.call(cells, function (c) { var im = c.querySelector('img'); if (im) im.loading = 'eager'; });
    cells[0].classList.add('is-on');
    if (reduced || cells.length < 2) return;
    var tile = col.closest('.cnh-tile'), hold = false;
    if (tile) {
      tile.addEventListener('mouseenter', function () { hold = true; });
      tile.addEventListener('mouseleave', function () { hold = false; });
    }
    setTimeout(function () {
      setInterval(function () {
        if (hold || document.hidden) return;
        cells[i].classList.remove('is-on');
        i = (i + 1) % cells.length;
        cells[i].classList.add('is-on');
      }, 2400);
    }, delay);
  }

  function init(section) {
    var style = styleFor(section);
    STYLES.forEach(function (s) { section.classList.remove('cnh-split--' + s); });
    section.classList.add('cnh-split--' + style);
    var cols = section.querySelectorAll('.cnh-collage');
    Array.prototype.forEach.call(cols, function (col, n) {
      if (style === 'marquee' && !reduced) buildMarquee(col);
      if (style === 'spotlight') startSpotlight(col, n * 600);
    });
    var even = style === 'grid' || style === 'flatlay';
    function arrange() { if (even) Array.prototype.forEach.call(cols, layout); }
    arrange();
    var fill = AREA[style] || 0.58;
    var cap = style === 'flatlay' ? 1.25 : 0.95; /* flat-lay pieces may overlap their neighbours */
    var imgs = section.querySelectorAll('.cnh-collage__cell img');
    Array.prototype.forEach.call(imgs, function (img) {
      if (img.complete && img.naturalWidth) fit(img, fill, cap);
      else img.addEventListener('load', function () { fit(img, fill, cap); }, { once: true });
    });
    if (window.ResizeObserver) {
      var t;
      new ResizeObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () { arrange(); Array.prototype.forEach.call(imgs, function (img) { fit(img, fill, cap); }); }, 120);
      }).observe(section);
    }
  }

  function run() { document.querySelectorAll('[data-cn-collage-style]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
